import { Icon, IconProps } from '@/components/ui/icon'
import { forwardRef, memo, type ReactNode } from 'react'

export default function createIcon(
  path: ReactNode,
  displayName: string
): typeof Icon {
  const Component = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
    return (
      <Icon ref={ref} aria-hidden='true' focusable='false' {...props}>
        {path}
      </Icon>
    )
  })

  Component.displayName = displayName

  return memo(Component)
}
